import { createSlice, createAsyncThunk, createEntityAdapter } from '@reduxjs/toolkit';
import axios from '../../utils/axios';

export const getAgents = createAsyncThunk('get/agents', async () => {
  const response = await axios.get('/agent/');
  return response.data;
});

export const getAgentById = createAsyncThunk('get/agentById', async (agentId) => {
  const response = await axios.get(`/agent/${agentId}/`);
  return response.data;
});

export const createAgent = createAsyncThunk('post/createAgent', async (agentData, { dispatch, rejectWithValue }) => {
  try {
    const response = await axios.post('/agent/', agentData);
    dispatch(getAgents());
    return response.data;
  } catch (error) {
    return rejectWithValue(error);
  }
});

export const updateAgent = createAsyncThunk(
  'put/updateAgent',
  async ({ agentID, agentData }, { dispatch, rejectWithValue }) => {
    try {
      const response = await axios.put(`/agent/${agentID}/`, agentData);
      dispatch(getAgents());
      return response.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const deleteAgent = createAsyncThunk('delete/deleteAgent', async (agentId, { dispatch, rejectWithValue }) => {
  try {
    const response = await axios.delete(`/agent/${agentId}/`);
    dispatch(getAgents());
    return response.data;
  } catch (error) {
    return rejectWithValue(error);
  }
});

export const deleteManyAgents = createAsyncThunk(
  'delete/deleteManyAgents',
  async (agentIds, { dispatch, rejectWithValue }) => {
    try {
      const response = await axios.delete('/agent/delete_many/', {
        data: {
          arrId: agentIds,
        },
      });
      dispatch(getAgents());
      return response.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

const agentAdapter = createEntityAdapter({});

const agentSlice = createSlice({
  name: 'agent',
  initialState: agentAdapter.getInitialState({
    agents: [],
    loading: false,
    isSubmitting: false,
  }),
  reducers: {},
  extraReducers: {
    [getAgents.pending]: (state) => {
      state.loading = true;
    },
    [getAgents.fulfilled]: (state, action) => {
      const { data } = action.payload;
      state.agents = data;
      state.loading = false;
    },
    [getAgents.rejected]: (state) => {
      state.loading = false;
    },
    // ---------------------------------------------
    [createAgent.pending]: (state) => {
      state.isSubmitting = true;
    },
    [createAgent.fulfilled]: (state) => {
      state.isSubmitting = false;
    },
    [createAgent.rejected]: (state) => {
      state.isSubmitting = false;
    },
    // ---------------------------------------------
    [updateAgent.pending]: (state) => {
      state.isSubmitting = true;
    },
    [updateAgent.fulfilled]: (state) => {
      state.isSubmitting = false;
    },
    [updateAgent.rejected]: (state) => {
      state.isSubmitting = false;
    },
  },
});

export const {} = agentSlice.actions;

export default agentSlice.reducer;
